import store from "../store";
import { actionTypes } from "./saga";

/**
 * @module TracksSaga
 */

/**
 *
 * @param {phoneNumber, timestamp} payload
 */
export function setTracksData(data) {
  store.dispatch({
    type: actionTypes.SET_TRACKS_DATA,
    payload: {
      data: data
    }
  });
}

export function clearTracksData() {
  store.dispatch({
    type: actionTypes.CLEAR_TRACKS_DATA
  });
}

export function setTrackingLoading(loading) {
  store.dispatch({
    type: actionTypes.PUT_TRACKING_LOADING,
    payload: {
      loading: loading
    }
  });
}

export function lastUpdatedAt() {
  store.dispatch({
    type: actionTypes.LAST_UPDATED_AT
  });
}
